import { httpsCallable } from "firebase/functions";
import { functions } from "@/base";

interface RubricaInput {
  version: string;
  descricao: string;
  criterios: TCriterioRubrica[];
}

interface CreateRubricaIdeiasRequest {
  licenciadaId: string;
  empresaId: string;
  regulamentoIdeiasId: string;
  rubrica: RubricaInput;
}

interface CreateRubricaIdeiasResponse {
  rubricaId: string;
  rubricaPath: string;
  rubricaVersion: string;
  rubricaHash: string;
}

export const createRubricaIdeias = httpsCallable<CreateRubricaIdeiasRequest, CreateRubricaIdeiasResponse>(
  functions,
  "rubricasIdeiasFunctions-createRubricaIdeias"
);

interface GerarCriteriosAutomaticamenteRequest {
  licenciadaId: string;
  empresaId: string;
  regulamentoIdeiasId: string;
  objetivosPrograma: string;
  nomePrograma?: string;
}

interface GerarCriteriosAutomaticamenteResponse {
  version: string;
  descricao: string;
  criterios: TCriterioRubrica[];
}

export const gerarCriteriosAutomaticamente = httpsCallable<
  GerarCriteriosAutomaticamenteRequest,
  GerarCriteriosAutomaticamenteResponse
>(functions, "rubricasIdeiasFunctions-gerarCriteriosAutomaticamenteFunction");
